import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createFeedback, fetchAllFeedback } from "../../api/FeedbackApi";

const USER_ID = "1";

type FeedbackStateType = {
    fetched: boolean,
    fetchingError: string,
    list: any[],

    submitted: boolean,
    submittingError: string
}

const initialState: FeedbackStateType = {
    fetched: false,
    list: [],
    fetchingError: '',

    submitted: false,
    submittingError: ''
}

const feedbackSlice = createSlice({
    name: 'feedback',
    initialState: initialState,
    reducers: {
        addFeedback: (state, action) => {
            state.list.push(action.payload);
        }
    },
    extraReducers: builder => {
        builder
            .addCase(loadAllFeedback.pending, (state: FeedbackStateType) => {
                state.fetched = false;
            })
            .addCase(loadAllFeedback.fulfilled, (state: FeedbackStateType, action: PayloadAction<any>) => {
                state.fetched = true;
                state.list = [...action.payload];
            })
            .addCase(loadAllFeedback.rejected, (state: FeedbackStateType) => {
                state.fetched = true;
                state.fetchingError = "Unable to load feedback.";
            })

            // submitting feedback
            .addCase(submitFeedback.pending, (state: FeedbackStateType) => {
                state.submitted = false;
            })
            .addCase(submitFeedback.fulfilled, (state: FeedbackStateType) => {
                state.submitted = true;
            })
            .addCase(submitFeedback.rejected, (state: FeedbackStateType) => {
                state.submitted = true;
                state.submittingError = "Unable to submit feedback.";
            })
    }
})

export const loadAllFeedback = createAsyncThunk(
    "feedback/loadAllFeedback",
    async () => {
        return await fetchAllFeedback(USER_ID)
    }
)

export const submitFeedback = createAsyncThunk(
    "feedback/submitFeedback",
    async (request: any, { dispatch }) => {
        const payload = {
            user_id: USER_ID,
            ...request
        }
        dispatch(addFeedback(payload));
        return await createFeedback(payload);
    }
)

const { addFeedback } = feedbackSlice.actions;

export default feedbackSlice.reducer;

export const selectUserFeedbacks = (state: any) => state.feedbacks.list;
export const selectIfFeedbackLoaded = (state: any) => state.feedbacks.fetched;
export const selectFeedbackLoadingError = (state: any) => state.feedbacks.fetchingError;

export const selectIfFeedbackGiven = (entry_id: string) => (state: any) => {
    const found = state.feedbacks.list.filter((f: any) => f.entry_id === entry_id)[0];
    return (found === undefined || found === null) ? null : found.rating;
};